import React, { useState, useEffect } from "react";
import Listing from "./Listing";
import Purchase from "./Purchase";
import Lease from "../../components/Checklists/Manitoba/LeaseTenant";
import Referral from "./Referral";
import LetterOfOpinion from "./LetterOfOpinion";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";

export default function ChecklistsMenu({ setProvince }) {
  const theme = createTheme({
    palette: {
      primary: {
        main: "#506CAA",
        dark: "#506CAA",
      },
      text: {
        primary: "#31303F",
        secondary: "#506CAA",
      },
    },
  });
  useEffect(() => {
    setProvince("MB");
  });

  const [TransactionType, setTransactionType] = useState("");

  const handleTransactionType = (e) => {
    setTransactionType(e.target.value);
  };

  return (
    <div className="flex flex-col w-full pt-5">
      <div className="flex items-center w-full pb-5">
        <ThemeProvider theme={theme}>
          <FormControl sx={{ mt: 2, ml: 2, minWidth: 200, maxWidth: 110 }}>
            <InputLabel size="small" className="select-default-label">
              Transaction Type
            </InputLabel>
            <Select
              value={TransactionType}
              name="Transaction Type"
              label="Transaction Type"
              onChange={handleTransactionType}
              size="small"
              sx={{ borderRadius: 20 }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    "& .MuiMenuItem-root": {
                      "&:hover": {
                        backgroundColor: "rgba(0, 0, 0, 0.04) !important",
                      },
                      "&.Mui-focusVisible": {
                        backgroundColor: "transparent !important",
                      },
                      "&.Mui-selected": {
                        backgroundColor: "transparent !important",
                      },
                      "&.Mui-selected:hover": {
                        backgroundColor: "rgba(0, 0, 0, 0.04) !important",
                      },
                    },
                  },
                },
              }}
            >
              <MenuItem key={Math.random()} value="Listing">
                Listing
              </MenuItem>
              <MenuItem key={Math.random()} value="Purchase">
                Purchase
              </MenuItem>
              <MenuItem key={Math.random()} value="Lease">
                Lease
              </MenuItem>
              <MenuItem key={Math.random()} value="Referral">
                Referral
              </MenuItem>
              <MenuItem key={Math.random()} value="LOO">
                Letter Of Opinion
              </MenuItem>
            </Select>
          </FormControl>
        </ThemeProvider>
      </div>
      {TransactionType === "Listing" ? <Listing /> : ""}
      {TransactionType === "Purchase" ? <Purchase /> : ""}
      {TransactionType === "Lease" ? <Lease /> : ""}
      {TransactionType === "Referral" ? <Referral /> : ""}
      {TransactionType === "LOO" ? <LetterOfOpinion /> : ""}
      {TransactionType === "" ? (
        <>
          <p className="pl-4">
            Select the side of the transaction you are currently dealing with.
            <br />
            <br />
            <strong>Example: </strong>If you already have a Listing and are
            dealing with a Buyer for that Listing, choose "Purchase".
          </p>
        </>
      ) : (
        ""
      )}
    </div>
  );
}
